import { lazy } from 'react'
import { IModuleDefinition } from '../types'

const DQRContainer = lazy(() => import('./ReconAIDataQualityContainer'))

const moduleDefinition: IModuleDefinition = {
  routeProps: {
    path: '/recon/*',
    private: true,
    component: DQRContainer
  },
  name: 'Recon Data Quality'
}

export default moduleDefinition

// export const advisorModuleReducer = combineReducers({
//   reconData: reconDataSummaryReducer,
//   dashboard: dashboardReducer
// })

// export const advisorModuleSagas = [...dashboardSagas, ...reconDataSummarySagas]
